"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTimeInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const date_fns_1 = require("date-fns");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const useLocale_1 = require("../../../../hooks/useLocale/useLocale");
const messages_1 = require("../../../../core/i18n/messages");
const global_enum_1 = require("../../../../core/global.enum");
const Styled = __importStar(require("./CustomTimeInput.styles"));
const CustomTimeInput = ({ date, setDate, isMinDateError, isTimeError, onTimeErrorChange, }) => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const timeFormat = 'HH:mm:ss';
    const timePlaceholder = '00:00:00';
    const [innerValue, setInnerValue] = (0, react_1.useState)(date);
    const isInternalChangeRef = (0, react_1.useRef)(false);
    // Sync innerValue with date prop, but skip if change came from this component
    (0, react_1.useEffect)(() => {
        if (isInternalChangeRef.current) {
            isInternalChangeRef.current = false;
            return;
        }
        setInnerValue(date);
        onTimeErrorChange?.(false);
    }, [date]);
    return ((0, jsx_runtime_1.jsxs)(Styled.InputWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.TimeLabel, { children: formatMessage({ id: messages_1.AppMessages['datepicker.popper.hour'] }) }), (0, jsx_runtime_1.jsx)(x_date_pickers_1.DesktopTimePicker, { ampm: false, openTo: "hours", views: ['hours', 'minutes', 'seconds'], inputFormat: global_enum_1.DateFormat.TIME, mask: "__:__:__", open: false, value: innerValue, renderInput: (params) => ((0, jsx_runtime_1.jsx)(Styled.Input, { ...params, variant: "filled", size: "small", inputProps: { ...params.inputProps, placeholder: timePlaceholder }, InputProps: {
                        disableUnderline: true,
                    }, "$isError": !!(isMinDateError || isTimeError) })), onChange: (_, value) => {
                    if (!value || !date)
                        return;
                    const beginOfStartDate = (0, date_fns_1.startOfDay)(date);
                    const parsedDate = (0, date_fns_1.parse)(value, timeFormat, beginOfStartDate);
                    // Check if parsed date is valid - shows error while typing invalid time
                    if (!(0, date_fns_1.isValid)(parsedDate)) {
                        onTimeErrorChange?.(true);
                        return;
                    }
                    onTimeErrorChange?.(false);
                    isInternalChangeRef.current = true;
                    setDate(parsedDate);
                } })] }));
};
exports.CustomTimeInput = CustomTimeInput;
